import styled from 'styled-components';
export const SubTitle = styled.p `
  text-align: center;
  font-weight: ${({ theme }) => theme.typography.fontWeight[400]};
  letter-spacing: ${({ theme }) => theme.spacing(0.05)};
`;
